import Lead from "../../../model/lead/Lead";
import LeadEvent from "../../../model/lead/event/LeadEvent";
import LeadStatusEvent from "../../../model/lead/event/LeadStatusEvent";
import {Option} from "ts-option";

/**
 * Create lead successful action.
 */
export const LEAD_CREATED = "LEAD_CREATED";
export type LEAD_CREATED = { lead: Lead };

/**
 * Single lead fetched action.
 */
export const LEAD_FETCHED = "LEAD_FETCHED";
export type LEAD_FETCHED = { lead: Lead };

/**
 * Edit lead successful action.
 */
export const LEAD_EDITED = "LEAD_EDITED";
export type LEAD_EDITED = { lead: Lead };

/**
 * Lead status update action.
 */
export const LEAD_STATUS_UPDATED = "LEAD_STATUS_UPDATED";
export type LEAD_STATUS_UPDATED = { leadId: string, statusId: string };

/**
 * Lead events fetched action.
 */
export const LEAD_EVENTS_FETCHED = "LEAD_EVENTS_FETCHED";
export type LEAD_EVENTS_FETCHED = { leadId: string, events: Array<LeadEvent | LeadStatusEvent> }
/**
 * Lead watchers updated action.
 */
export const LEAD_WATCHERS_UPDATED = "LEAD_WATCHERS_UPDATED";
export type  LEAD_WATCHERS_UPDATED = { leadId: string, watchers: string[] };
/**
 * Agent updated action.
 */
export const LEAD_AGENT_UPDATED = "LEAD_AGENT_UPDATED";
export type LEAD_AGENT_UPDATED = { leadId: string, agentId: Option<string> };